import { Badge } from '@mantine/core';
import { EtcTicketState, ETC_TICKET_STATE_POLICY } from '../model';

const STATE_BADGE_COLOR: Record<EtcTicketState, string> = {
  [EtcTicketState.PENDING]: 'yellow',
  [EtcTicketState.NO_FEE]: 'gray',
  [EtcTicketState.QUERY_FAILED]: 'red',
  [EtcTicketState.CHARGE_FAILED]: 'orange',
  [EtcTicketState.CHARGE_SUCCESS]: 'green',
  [EtcTicketState.COMPLETED]: 'teal',
};

export const EtcStateBadge = ({ state }: { state: EtcTicketState }) => (
  <Badge color={STATE_BADGE_COLOR[state]} variant="light" size="lg">
    {ETC_TICKET_STATE_POLICY[state].text}
  </Badge>
);
